import React, { useEffect, useState } from 'react';
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import iteam from "./Iteam";
import {useDispatch, useSelector} from "react-redux";
import { addPokemon as addPokemonTeam1, removePokemon as removePokemonTeam1 } from '../teams/Team1Slice';
import { addPokemon as addPokemonTeam2, removePokemon as removePokemonTeam2 } from '../teams/Team2Slice';
import { ToastContainer, toast } from 'react-toastify';

const Pokemon = () => {
    const { name: pokemonName } = useParams();
    const [pokemon, setPokemon] = useState(null);
    const [pokemonchaintrue, setPokemonchaintrue] = useState(null);
    const [evolutionUrls, setEvolutionUrls] = useState([]);
    const [evolutioUrl, setEvolutioUrls] = useState([]);
    const team1 = useSelector(state => state.team1.team || []);
    const team2  = useSelector(state => state.team2.team || []);
    const dispatch = useDispatch();
    const [curTeam,setCurTeam] = useState(localStorage.getItem(1));
    const toggleTeam = () => {
        let a = localStorage.getItem(1);
        if(a === "team1")
        {
            localStorage.setItem(1,"team2")
            setCurTeam(localStorage.getItem(1))
            toast.info('Changed to team 2', {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,

                progress: undefined,
                theme: "dark",

            });
        }
        else
        {
            localStorage.setItem(1,"team1")
            setCurTeam(localStorage.getItem(1))
            toast.info('Changed to team 1', {
                position: "bottom-right",
                autoClose: 3000,
                limit:2,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",

            });
        }
    };
    const AddOrRemove = () => {
        if(localStorage.getItem(1) === "team1")
        {
            if (team1.includes(pokemonName)) {


                return <button className={"bg-gray-300 py-1 rounded  p-5 m-1"} onClick={() => {
                    dispatch(removePokemonTeam1(pokemonName));

                        toast.success(`${pokemonName} removed from team 1`, {
                            position: "bottom-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",

                        });

                }}>remove from team</button>;
            } else {

                return <button className={"bg-gray-300  py-1 rounded  p-5 m-1"} onClick={() => {
                    dispatch(addPokemonTeam1(pokemonName));
                    if(team1.length < 6)
                    {
                        toast.success(`${pokemonName} added to team 1`, {
                            position: "bottom-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",

                        });
                    }
                    else{
                        toast.error(`team 1 is full ${pokemonName} cannot be added`, {
                            position: "bottom-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",

                        });
                    }


                }}>add to team</button>;
            }
        }
        else
        {
            if (team2.includes(pokemonName)) {

                return <button className={"bg-gray-300 py-1 rounded  p-5 m-1"}onClick={() => {
                    dispatch(removePokemonTeam2(pokemonName));
                    toast.success(`${pokemonName} removed from team 2`, {
                        position: "bottom-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "dark",

                    });

                }}>remove from team</button>;
            } else {

                return <button className={"bg-gray-300  py-1 rounded  p-5 m-1"} onClick={() => {
                    dispatch(addPokemonTeam2(pokemonName));
                    if(team2.length < 6)
                    {
                        toast.success(`${pokemonName} added to team 2`, {
                            position: "bottom-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",

                        });
                    }
                    else{
                        toast.error(`team 2 is full ${pokemonName} cannot be added`, {
                            position: "bottom-right",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "dark",

                        });
                    }

                }}>add to team</button>;
            }
        }

    }
    const extractEvolutionUrls = (chain, urls = []) => {
        if (!chain) return urls;
        urls.push(chain.species.url);
        chain.evolves_to.forEach(evo => extractEvolutionUrls(evo, urls));
        return urls;
    };

    useEffect(() => {
        axios.get(`https://pokeapi.co/api/v2/pokemon/${pokemonName}`)
            .then(res => setPokemon(res.data))
            .catch(err => console.error(err));
    }, [pokemonName]);

    useEffect(() => {
        axios.get(`https://pokeapi.co/api/v2/pokemon-species/${pokemonName}`)
            .then(res => axios.get(res.data.evolution_chain.url))
            .then(res => setPokemonchaintrue(res.data))
            .catch(err => console.error(err));
    }, [pokemonName]);

    useEffect(() => {
        if (pokemonchaintrue?.chain) {
            const urls = extractEvolutionUrls(pokemonchaintrue.chain);
            setEvolutionUrls(urls);
        }
    }, [pokemonchaintrue]);

    useEffect(() => {
        const fetchEvolutionDetails = async () => {
            try {
                const result = await Promise.all(
                    evolutionUrls.map(url => axios.get(url).then(res => res.data))
                );
                setEvolutioUrls(result);
            } catch (error) {
                console.error("Chyba při načítání evolucí:", error);
            }
        };
        if (evolutionUrls.length) fetchEvolutionDetails();
    }, [evolutionUrls]);

    if (!pokemon ) return <p>Načítám data...</p>;
    console.log(pokemon)
    return (
        <div className={"max-w-4xl mx-auto mt-10 p-4 bg-white rounded shadow space-y-4"}>
        <h1 className={"text-3xl font-bold mb-6 text-center"}>{curTeam.toUpperCase()}</h1>
        <div className="">
            <div className="flex items-center space-x-4">
                <img src={pokemon.sprites.front_shiny} alt={"no image found"} className="w-24 h-24 hover:animate-spin" />
                <h1 className="text-3xl font-bold capitalize">{pokemon.name}</h1>
                <Link to={"/pokemons"}>
                    <button  className="bg-gray-300 px-4 py-1 rounded hover:bg-gray-400">Zpět</button>
                </Link>



            </div>
            <AddOrRemove/>
            <button onClick={toggleTeam} className="bg-gray-300 px-4 py-1 rounded hover:bg-gray-400 ">change to team</button>
            <div>
                <h2 className="text-xl font-semibold">Abilities:</h2>
                <ul className="list-disc list-none ">
                    {pokemon.abilities.map((item, i) => (
                        <li key={i} className={""}>
                            <Link to={`/pokemons/Abiliti/${encodeURIComponent(item.ability.url)}`} className={"text-blue-400"}>
                                {item.ability.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            <div>
                <h2 className="text-xl font-semibold">Evoluce</h2>
                <ul>
                    {evolutioUrl.map((item, i) => (
                        <Link to={`/pokemons/${item.name}`} onClick={() => {
                        }} key={i} className={"text-emerald-400"}>
                            <li>{item.name}</li>
                        </Link>
                    ))}
                </ul>
            </div>
            <div>
                <h2 className="text-xl font-semibold">Type</h2>
                <ul>
                    {pokemon.types.map((item,i) =>(
                        <li className={"text-gray-500"}>{item.type.name}</li>
                    ))}
                </ul>
            </div>
            <div>
                <h2 className="text-xl font-semibold">Size</h2>
                <div>
                    <p className={"text-amber-700"}>Výška: {pokemon.height}</p>
                    <p className={"text-amber-700"}>Váha: {pokemon.weight}</p>
                </div>
            </div>

            <div>
                <h2 className="text-xl font-semibold">Stats</h2>
                <ul className="list-disc list-none">
                    {pokemon.stats.map((item, i) => (
                        <li className={"text-violet-700"} key={i}>{item.stat.name}: {item.base_stat}</li>
                    ))}
                </ul>
            </div>

            <div>
                <h2 className="text-xl font-semibold">Moves</h2>
                <ul className="grid grid-cols-2 gap-2 max-h-48 overflow-y-auto">
                    {pokemon.moves.map((item, i) => (
                        <li className={"text-sky-600"} key={i}>{item.move.name}</li>
                    ))}
                </ul>
            </div>
        </div>
            <ToastContainer
                position="bottom-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
            />
        </div>
    );
};

export default Pokemon;
